import "./StartPage.scss";

import { LoginBox } from "../../modules/LoginBox";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { StepBox } from "./StepBox";

import { ContentConfig, StartPageNotice } from "../../types/ContentConfig";
import tenantService from "../../services/TenantService";
import AppContainer from "../../components/app-container/AppContainer";
import logoPaymentCH from "../../../resources/images/ch-eos/Logoleiste_footer_2022.svg";
import logoPaymentDE from "../../../resources/images/de-did/Logoleiste_footer_2022.svg";

export interface InfoBoxContent {
    ICON?: string;
    HEADLINE?: string;
    TEXT?: string;
    LINK_URL?: string;
    LINK_TEXT?: string;
}

export const StartPage: React.FC = () => {
    const { t } = useTranslation();
    const [config, setConfig] = React.useState<ContentConfig>();
    const [tenant, setTenant] = React.useState<string>("");

    React.useEffect(() => {
        initData();
    }, []);

    const initData = async () => {
        const tenant = await tenantService.getTenant();
        const config = await tenantService.getConfig(tenant);

        setTenant(tenant);
        setConfig(config);
    };
    const infoBoxes = t("INFOBOXES", { returnObjects: true }) as InfoBoxContent[];

    const isNoticekAvailable = (notice: StartPageNotice): boolean => {
        if (!config) {
            return false;
        }
        if (config.startPageNotice != undefined) {
            return config.startPageNotice.includes(notice);
        }
        return false;
    };

    return (
        <>
            <AppContainer header={{ menuLoginEnabled: false }}>
                <div className="startPage">
                    <div className="headerImage">
                        <LoginBox></LoginBox>
                    </div>
                    <div className="content">
                        <div className="threeStepBoxes">
                            <div className="text">
                                <h1 role="heading">{t("THREESTEPSBOX.HEADLINE")}</h1>
                                <p>{t("THREESTEPSBOX.TEXT")}</p>
                            </div>
                            <div className="threeSteps">
                                <StepBox number="1" icon="icon-claimnumber" text={t("THREESTEPSBOX.STEP1")} />
                                <i className="icon-arrow-right" />
                                <StepBox number="2" icon="icon-pay-claim-note" text={t("THREESTEPSBOX.STEP2")} />
                                <i className="icon-arrow-right" />
                                <StepBox number="3" icon="icon-chargetoclaim-V1" text={t("THREESTEPSBOX.STEP3")} />
                            </div>
                        </div>

                        <div className="infoBoxes">
                            {infoBoxes &&
                                infoBoxes.length > 0 &&
                                infoBoxes.map((infoBox, index) => (
                                    <section key={index}>
                                        <div className="box">
                                            <i className={infoBox.ICON}></i>
                                            <div className="boxStyle">
                                                <p className="headlineBox">{infoBox.HEADLINE}</p>
                                                <p className="text">{infoBox.TEXT}</p>
                                                <a href={infoBox.LINK_URL}>
                                                    <p className="link">
                                                        <i className="icon-arrow-simple-right" />
                                                        {infoBox.LINK_TEXT}
                                                    </p>
                                                </a>
                                            </div>
                                        </div>
                                    </section>
                                ))}
                        </div>
                        {isNoticekAvailable(StartPageNotice.NOTICE) && (
                            <div>
                                <div className="notice">
                                    <h4>
                                        <Trans i18nKey={"NOTICE.HEADLINE"}></Trans>
                                    </h4>
                                    <p>
                                        <Trans i18nKey={"NOTICE.TEXT"}></Trans>
                                    </p>
                                </div>
                            </div>
                        )}
                        {tenant == "ch-eos" ||
                            (tenant == "de-did" && (
                                <div>
                                    <img className="paymentLogosFooter" src={getPaymentLogo(tenant)} alt="Payment Logos" />
                                </div>
                            ))}
                    </div>
                </div>
            </AppContainer>
        </>
    );
};

export function getPaymentLogo(tenant: string | undefined) {
    switch (tenant) {
        case "ch-eos":
            return logoPaymentCH;
        case "de-did":
            return logoPaymentDE;
        default:
            return "";
    }
}
